module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/e559f3a36902c9285228b7e842e75dc6.png";